import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { HiArrowRight } from "react-icons/hi";
import { MdChat } from "react-icons/md";

import { analytics } from "MVVM/Analytics";
import { useUser } from "MVVM/Hooks/useUser";
import { SurveyPromptState } from "MVVM/State/survey";
import {
  SurveyBody,
  SurveyHeader,
  SurveyIcon,
  SurveyPrimaryButton,
  SurveySecondaryButton,
  SurveySecondaryRow,
  SurveySurface,
  SurveyTitle,
} from "./styledComponents";

const SURVEY_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSds1H2QSH_pbisZfXrj9rAreUN6n19rBQ--icDzYENntK4aeA/viewform";

const SNOOZE_MS = 86_400_000;
const APPEAR_DELAY_MS = 4_000;

export const SurveyCard = () => {
  const [prompt, setPrompt] = useRecoilState(SurveyPromptState);
  const { allstarUser } = useUser();
  const [delayElapsed, setDelayElapsed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setDelayElapsed(true), APPEAR_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const snoozed = !!prompt.snoozedUntil && prompt.snoozedUntil > Date.now();
  const show =
    delayElapsed &&
    allstarUser.loggedIn &&
    !prompt.dismissedForever &&
    !snoozed;

  useEffect(() => {
    if (show) analytics.track("Survey Prompt - Impression", {});
  }, [show]);

  if (!show) return null;

  const takeSurvey = () => {
    analytics.track("Survey Prompt - Accepted", {});
    window.open(SURVEY_URL, "_blank", "noopener,noreferrer");
    setPrompt({ snoozedUntil: null, dismissedForever: true });
  };

  const askLater = () => {
    analytics.track("Survey Prompt - Snoozed", {});
    setPrompt({
      snoozedUntil: Date.now() + SNOOZE_MS,
      dismissedForever: false,
    });
  };

  const declineForever = () => {
    analytics.track("Survey Prompt - Declined", {});
    setPrompt({ snoozedUntil: null, dismissedForever: true });
  };

  return (
    <SurveySurface
      aria-label="Got 2 minutes?"
      onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key === "Escape") askLater();
      }}
      role="group"
    >
      <SurveyHeader>
        <SurveyIcon>
          <MdChat size={26} />
        </SurveyIcon>
        <div>
          <SurveyTitle>Got 2 minutes?</SurveyTitle>
          <SurveyBody>
            Take a quick survey to help improve Allstar. 5 lucky players get a
            free month of Unlimited.
          </SurveyBody>
        </div>
      </SurveyHeader>
      <SurveyPrimaryButton onClick={takeSurvey} type="button">
        Take the survey
        <HiArrowRight size={17} />
      </SurveyPrimaryButton>
      <SurveySecondaryRow>
        <SurveySecondaryButton onClick={askLater} type="button">
          Ask me later
        </SurveySecondaryButton>
        <SurveySecondaryButton onClick={declineForever} type="button">
          No thanks
        </SurveySecondaryButton>
      </SurveySecondaryRow>
    </SurveySurface>
  );
};
